module.exports = __webpack_public_path__ + "static/media/ednilson-sacramento.d9c1b06b.jpeg";